import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useInvoiceStore = create()(
    persist(
        (set) => ({
            // State
            invoicePaymentStatus: [],
            isPinned: false,
            page: 1,
            rowsPerPage: 10,
            search: '',
            tabValue: 0,
            dateData: '',
            selectDate: null,
            yearData: '',
            makeData: '',
            modelData: '',
            licenseNumber: '',
            fleetUnitNumber: '',
            provinceId: '',
            vinFilter: '',
            sortTypeDate: '',
            sortByDate: 'createdAt',
            sortTypeName: '',
            sortTypeTotal: '',
            showInvoiceLicensePlateColumn: false,
            showInvoiceUnitColumn: false,

            // Setters
            setInvoicePaymentStatus: (statuses) => set({ invoicePaymentStatus: statuses }),
            setPinned: (value) => set({ isPinned: value }),
            setPage: (page) => set({ page }),
            setRowsPerPage: (rowsPerPage) => set({ rowsPerPage }),
            setSearch: (search) => set({ search }),
            setTabValue: (tabValue) => set({ tabValue }),
            setDateData: (dateData) => set({ dateData }),
            setSelectDate: (selectDate) => set({ selectDate }),
            setYearData: (yearData) => set({ yearData }),
            setMakeData: (makeData) => set({ makeData }),
            setModelData: (modelData) => set({ modelData }),
            setLicenseNumber: (licenseNumber) => set({ licenseNumber }),
            setFleetUnitNumber: (fleetUnitNumber) => set({ fleetUnitNumber }),
            setProvinceId: (provinceId) => set({ provinceId }),
            setVinFilter: (vinFilter) => set({ vinFilter }),
            setSortTypeDate: (sortTypeDate) => set({ sortTypeDate }),
            setSortByDate: (sortByDate) => set({ sortByDate }),
            setSortTypeName: (sortTypeName) => set({ sortTypeName }),
            setSortTypeTotal: (sortTypeTotal) => set({ sortTypeTotal }),
            setShowInvoiceLicensePlateColumn: (showInvoiceLicensePlateColumn) => set({ showInvoiceLicensePlateColumn }),
            setShowInvoiceUnitColumn: (showInvoiceUnitColumn) => set({ showInvoiceUnitColumn }),
            resetInvoiceTableColumns: () =>
                set({
                    showInvoiceLicensePlateColumn: false,
                    showInvoiceUnitColumn: false,
                }),

            resetInvoiceStore: () =>
                set((state) => ({
                    page: 1,
                    rowsPerPage: 10,
                    search: '',
                    tabValue: 0,
                    dateData: '',
                    selectDate: null,
                    yearData: '',
                    makeData: '',
                    modelData: '',
                    licenseNumber: '',
                    fleetUnitNumber: '',
                    provinceId: '',
                    vinFilter: '',
                    sortTypeDate: '',
                    sortByDate: 'createdAt',
                    sortTypeName: '',
                    sortTypeTotal: '',
                    showInvoiceLicensePlateColumn: state.showInvoiceLicensePlateColumn,
                    showInvoiceUnitColumn: state.showInvoiceUnitColumn,
                    isPinned: state.isPinned,
                    invoicePaymentStatus: state.isPinned ? state.invoicePaymentStatus : [],
                })),
        }),
        {
            name: 'invoice-store',
            partialize: (state) => ({
                invoicePaymentStatus: state.invoicePaymentStatus,
                isPinned: state.isPinned,
                page: state.page,
                rowsPerPage: state.rowsPerPage,
                search: state.search,
                tabValue: state.tabValue,
                dateData: state.dateData,
                selectDate: state.selectDate,
                yearData: state.yearData,
                makeData: state.makeData,
                modelData: state.modelData,
                licenseNumber: state.licenseNumber,
                fleetUnitNumber: state.fleetUnitNumber,
                provinceId: state.provinceId,
                vinFilter: state.vinFilter,
                sortTypeDate: state.sortTypeDate,
                sortByDate: state.sortByDate,
                sortTypeName: state.sortTypeName,
                sortTypeTotal: state.sortTypeTotal,
                showInvoiceLicensePlateColumn: state.showInvoiceLicensePlateColumn,
                showInvoiceUnitColumn: state.showInvoiceUnitColumn,
            }),
        }
    )
);

export default useInvoiceStore;
